var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Loading.css';
export default function Loading(props) {
    return (_jsx("span", __assign({ className: 'Loading ' + props.className, style: props.style }, { children: _jsx("span", __assign({ className: props.animation ? props.animation : 'rotate' }, { children: props.children ? props.children : _jsx(FontAwesomeIcon, { icon: faCircleNotch }, void 0) }), void 0) }), void 0));
}
//# sourceMappingURL=Loading.js.map